// packages block
import React from "react";
import { TableRow, TableCell, makeStyles } from "@material-ui/core";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { capitalizeFirstLetter } from "../../../util/stringManipulation";
import CustomCheckbox from "../../customCheckbox";

const useStyles = makeStyles({
  customTable: {
    "& .MuiTableCell-alignLeft": {
      padding: "22px 0px 22px 0px",
    },
  },
});
export const StudentRow = ({
  isItemSelected,
  selectionKey,
  handleClick,
  row,
  openActionMenu,
  actionButtonClass,
  labelId,
}) => {
  const classes = useStyles();

  const firstName = capitalizeFirstLetter(row["firstName"] ?? "");
  const lastName = capitalizeFirstLetter(row["lastName"] ?? "");
  const name = firstName || lastName ? `${firstName} ${lastName}` : "N/A";
  const grade = row["grade"] ? row["grade"] : "N/A";
  const phoneNumber = row["phoneNumber"] ? row["phoneNumber"] : "N/A";

  return (
    <TableRow
      hover
      style={{
        borderBottom: "1px solid #636365",
        backgroundColor: isItemSelected ? "#FAF9F6" : "white",
      }}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.name}
      selected={isItemSelected}
      classes={{ root: classes.customTable }}
    >
      <TableCell padding="checkbox">
        <CustomCheckbox
          onClick={(event) => handleClick(event, row[selectionKey])}
          checked={isItemSelected}
          inputProps={{ "aria-labelledby": labelId }}
        />
      </TableCell>

      <TableCell align="left" style={{ fontWeight: 500, padding: 10 }}>
        {row["payeeType"] === "STUDENT"
          ? row["studentRegNo"]
          : row["parentRegNo"]}
      </TableCell>
      {/* <TableCell align="left">{row["payeeType"]}</TableCell> */}
      <TableCell
        align="left"
        style={{ textTransform: "capitalize", fontWeight: 500, padding: 10 }}
      >
        {name}
      </TableCell>
      <TableCell align="left" style={{ fontWeight: 500, padding: 10 }}>
        {grade}
      </TableCell>
      <TableCell align="left" style={{ fontWeight: 500, padding: 10 }}>
        {phoneNumber}
      </TableCell>
      <TableCell align="left">
        <div
          role="presentation"
          onClick={(e) => {
            openActionMenu(e, row);
          }}
          className={actionButtonClass}
        >
          <MoreHorizIcon style={{ color: "black" }} />
        </div>
      </TableCell>
    </TableRow>
  );
};
